
import SceneObject from "./SceneObject";
import EditHandleData from "../sceneObjectData/EditHandleData";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";
import ChecklistItemData from "../sceneObjectData/ChecklistItemData";

export default class ChecklistItemSceneObject extends SceneObject<ChecklistItemData> {

    // A checklist item points at a checklist entry in the external app that created it, and
    // ChecklistItemData.clone() copies that id by value - two scene objects claiming the same entry
    // is not a meaningful thing to have. Its sceneObjectTypeData wouldn't survive the round trip
    // either, since toJson() never serializes it.
    canClone(): boolean {
        return false;
    }

    // The checklist entry itself is managed in the external app, and the item is repositioned
    // through its own edit handle, so the generic selection toolbar has nothing to offer it.
    hasSelectionContextToolbar(): boolean {
        return false;
    }

    getEditHandles(): EditHandleData[] {
        const data = this.data;
        return [
            new EditHandleData(data.uuid, EditHandleTypeEnum.START_POINT, data.position.clone(),
                CommandIdEnum.ChecklistFreeMove,
                (d, delta) => (d as ChecklistItemData).position.add(delta)),
        ];
    }
}
